export const MAX_DELIVERY_DATE_RANGE_DAYS = 90;
export const DEFAULT_DELIVERY_DATE_RANGE_DAYS = 30;
export const MAX_DELIVERY_PAGE_SIZE = 30;

/** Formata Date ou string parseável para yyyy-MM-dd (LocalDate da API). */
export function formatDateIsoLocal(date) {
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/** Intervalo padrão: últimos 30 dias até hoje. */
export function getDefaultDeliveryDateRange() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - DEFAULT_DELIVERY_DATE_RANGE_DAYS);
    return {
        startDate: formatDateIsoLocal(start),
        endDate: formatDateIsoLocal(end),
    };
}

/**
 * Valida intervalo de datas de criação.
 * @param {string} startDate
 * @param {string} endDate
 * @param {number} [maxDays] Limite em dias. Padrão: {@link MAX_DELIVERY_DATE_RANGE_DAYS}.
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateDeliveryDateRange(startDate, endDate, maxDays) {
    if (!startDate || !endDate) {
        return { valid: true };
    }
    const start = new Date(`${startDate}T00:00:00`);
    const end = new Date(`${endDate}T00:00:00`);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        return { valid: false, message: 'Informe datas válidas.' };
    }
    if (end < start) {
        return { valid: false, message: 'A data final deve ser igual ou posterior à data inicial.' };
    }
    const limit = Number.isInteger(maxDays) && maxDays > 0
        ? maxDays
        : MAX_DELIVERY_DATE_RANGE_DAYS;
    const diffMs = end.getTime() - start.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays > limit) {
        return {
            valid: false,
            message: `O intervalo não pode exceder ${limit} dias.`,
        };
    }
    return { valid: true };
}
